import React from 'react';
import PublicPageLayout from '../components/marketing/PublicPageLayout';
import LanguageMatrix from '../components/LanguageMatrix';

const LanguageView = () => (
  <PublicPageLayout>
    <LanguageMatrix />
  </PublicPageLayout>
);

export default LanguageView;
